import { render, staticRenderFns } from "./GStudentRecordRecommendationLetterGeneration.vue?vue&type=template&id=56961d2e&scoped=true&"
import script from "./GStudentRecordRecommendationLetterGeneration.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordRecommendationLetterGeneration.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordRecommendationLetterGeneration.vue?vue&type=style&index=0&id=56961d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56961d2e",
  null
  
)

export default component.exports